import { useQuery } from "@tanstack/react-query";

import { RepresentApi } from "../api/RepresentApi";

export const GEO_BOUNDARY_QUERY = (lat: string, lon: string) => [
  "geo_boundary",
  lat,
  lon,
];

export const useGeoBoundaryQuery = (lat = 0, lon = 0, enabled = true) => {
  const latitude = lat.toFixed(5);
  const longitude = lon.toFixed(5);
  return useQuery({
    queryFn: () => RepresentApi.getBoundaryForCoordiates(latitude, longitude),
    queryKey: GEO_BOUNDARY_QUERY(latitude, longitude),
    enabled,
  });
};
